import React, { useMemo } from 'react';
import isNil from 'lodash/isNil';
import { Field as AkField, ErrorMessage as AkErrorMessage } from '@atlaskit/form';
import AkSelect from '@atlaskit/select';
import { useIntl } from '@atlassian/jira-intl';
import type { SelectOption, SelectOptions } from '../../../../../common/types';
import { TIMEZONE } from '../../../../../common/ui/constants.tsx';
import messages from './messages';

type Props = {
	defaultTimeZone: SelectOption;
	selectedTimeZoneId?: string;
	options: SelectOptions;
};

const Timezone = ({ defaultTimeZone, selectedTimeZoneId, options }: Props) => {
	const defaultValue = useMemo(() => {
		const timezoneId = isNil(selectedTimeZoneId) ? defaultTimeZone.value : selectedTimeZoneId;
		return options.find((option) => option.value === timezoneId);
	}, [defaultTimeZone.value, options, selectedTimeZoneId]);
	const { formatMessage } = useIntl();

	return (
		<div data-testid="servicedesk-sla-settings.ui.calendars.editable.fields.timezone">
			<AkField
				name={TIMEZONE}
				label={formatMessage(messages.timezone)}
				defaultValue={defaultValue}
				isRequired
			>
				{({ fieldProps, error }) => (
					<>
						{/* @ts-expect-error - TS2322 - Type '{ options: SelectOptions; id: string; isRequired: boolean; isDisabled: boolean; isInvalid: boolean; onChange: (value: FormEvent<HTMLInputElement> | SelectOption) => void; ... 5 more ...; 'aria-labelledby': string; }' is not assignable to type 'Readonly<SelectProps<SelectOption, false>>'. */}
						<AkSelect {...fieldProps} options={options} />
						{error !== undefined && <AkErrorMessage>{error}</AkErrorMessage>}
					</>
				)}
			</AkField>
		</div>
	);
};

export const TimezoneField = Timezone;
